import { render, staticRenderFns } from "./routersAdd.vue?vue&type=template&id=3148c36f&scoped=true&"
import script from "./routersAdd.vue?vue&type=script&lang=js&"
export * from "./routersAdd.vue?vue&type=script&lang=js&"
import style0 from "./routersAdd.vue?vue&type=style&index=0&id=3148c36f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3148c36f",
  null
  
)

export default component.exports